import { isFeatureEnabled } from "./appConfigurations";

// Removes the Reports column, with its Report and Data buttons, from the Sites
// list (CS AB#50175). Off = the list as it was before; the site page keeps
// Report and Data either way.
export const REMOVE_SITES_REPORTS_COLUMN_FEATURE_FLAG =
  "CS_50175_REMOVE_SITES_REPORTS_COLUMN";

export const selectRemoveSitesReportsColumnEnabled = isFeatureEnabled(
  REMOVE_SITES_REPORTS_COLUMN_FEATURE_FLAG
);
